import { Injectable } from '@angular/core';

declare let chmln: any;

@Injectable({
  providedIn: 'root'
})
export class ChameleonService {

  constructor() {
  }

  clearChameleonIdentity() {
    chmln.clear();
  }

  trySetChameleonIdentity() {
    if (!localStorage["session"]) return;
    let userData = JSON.parse(localStorage["session"]);

    /* chameleon.io user identification and data */
    chmln.identify(userData.ID, {     // REQUIRED, the unique ID of each user in your database (e.g. 23443 or "690b80e5f433ea81b96c9bf6")
      email: userData.Email,                // RECOMMENDED, email is used as the key to map user data for integrations
      name: userData.Name,             // RECOMMENDED, name can be used to greet and/or personalize content
      role: userData.RoleCode
    });
  }
}